import axios from "axios";

export default axios.create({
  baseURL: "https://yf7ptz0qn3.execute-api.us-east-1.amazonaws.com/dev",
  headers: {
    "Content-type": "application/json",
    "Cache-Control": "max-age=0"
  }
});
